export const baseInfo = getCssVar("--color-info")
export const baseWarning = getCssVar("--color-warning")
export const basePrimary = getCssVar("--color-primary")
export const baseSuccess = getCssVar("--color-success")
export const baseError = getCssVar("--color-error")
export const baseWhite = getCssVar("--color-white")
export const basePurple = getCssVar("--color-purple")

export function lighten(hex: string, amt = 10) {
  return shift(hex, +amt)
}
export function darken(hex: string, amt = 10) {
  return shift(hex, -amt)
}

function shift(hex: string, amt: number) {
  const { r, g, b } = hexToRgb(hex)
  const clamp = (v: number) => Math.max(0, Math.min(255, v))
  const f = amt / 100
  const rr = clamp(Math.round(r + (255 - r) * (f > 0 ? f : 0) + (f < 0 ? r * f : 0)))
  const gg = clamp(Math.round(g + (255 - g) * (f > 0 ? f : 0) + (f < 0 ? g * f : 0)))
  const bb = clamp(Math.round(b + (255 - b) * (f > 0 ? f : 0) + (f < 0 ? b * f : 0)))
  return rgbToHex(rr, gg, bb)
}

function hexToRgb(hex: string) {
  const m = hex.replace("#", "")
  const n =
    m.length === 3
      ? m
          .split("")
          .map((c) => c + c)
          .join("")
      : m
  const num = parseInt(n, 16)
  return { r: (num >> 16) & 255, g: (num >> 8) & 255, b: num & 255 }
}

function rgbToHex(r: number, g: number, b: number) {
  return `#${[r, g, b].map((v) => v.toString(16).padStart(2, "0")).join("")}`
}

export function getCssVar(name: string, el: HTMLElement = document.documentElement) {
  return getComputedStyle(el).getPropertyValue(name).trim()
}
